<header>
  <div class="wrap">
    <div class="text">
      <h2 class="title">
        <svg class="icon-action-warning">
          <use xlink:href="assets/img/icons.svg#icon-action-warning"></use>
        </svg>
        {{ 'popins.generic-error.title' | translate }}
      </h2>
      <p class="my-5">{{ errorMessage }}</p>
    </div>
    <div class="header-actions">
      <button class="close" (click)="modalService.close()" title="{{ 'generic.close' | translate }}">
        <span class="icon-view-close" aria-hidden="true">
          <svg>
            <use xlink:href="assets/img/icons.svg#icon-view-close"></use>
          </svg>
        </span>
        <span>{{ 'generic.close' | translate }}</span>
      </button>
    </div>
  </div>
</header>
<div class="main">
  <footer class="popin-footer">
    <ng-casto-btn
      class="blue"
      [label]="'popins.generic-error.confirm' | translate"
      (click)="modalService.close()"></ng-casto-btn>
  </footer>
</div>
